// extracted by mini-css-extract-plugin
export default {"FormItem":"number_FormItem__0+rNO"};